export function section16() {
    
    gsap.timeline({
        scrollTrigger: {
            trigger: ".section.slice-16",
            start: "top top",
            scrub: false,
        },
    })
    .from(".section.slice-16 .image-gallery#image-01 div", {
        width: 0,
        duration: 1,
        ease: "expo.out"
    })
    .from(".section.slice-16 .image-gallery#image-02 div", {
        height: 0,
        duration: 1,
        ease: "expo.out"
    }, "<+0.25")
}